import { render, staticRenderFns } from "./UpdateRelatedProtocols.vue?vue&type=template&id=21222c2a&scoped=true"
import script from "./UpdateRelatedProtocols.vue?vue&type=script&lang=js"
export * from "./UpdateRelatedProtocols.vue?vue&type=script&lang=js"
import style0 from "./UpdateRelatedProtocols.vue?vue&type=style&index=0&id=21222c2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21222c2a",
  null
  
)

export default component.exports